import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { usePspAuth } from '../context/PspAuthContext';

/**
 * Guards candidate-only routes, redirecting to the login of the same friendly_url.
 */
const PrivateRoute = ({ children }) => {
    const { friendly_url } = useParams();
    const { isAuthenticated } = usePspAuth();

    if (!isAuthenticated) {
        return <Navigate to={`/processos-seletivos/${friendly_url}/login`} replace />;
    }
    return children;
};

export default PrivateRoute;
